import React, { useRef, useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import qmsTeamActions from "../../../_actions/_qmsActions/qmsTeamActions";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";

export default function CmtModal_EditPrimaryOwner(props) {
  const { modalState, toggleModal } = props;

  const dispatch = useDispatch();
  useEffect(() => dispatch(qmsTeamActions.getAll(modalState.data.divisionId)), []);
  const qmsTeams = useSelector(
    (state) => state.qms.qmsTeams[modalState.data.divisionId] || null
  );
  const qmsTeamOptions = useMemo(
    () => (qmsTeams || []).map((qt) => ({ value: qt.qmsTeamId, label: qt.name })),
    [qmsTeams]
  );

  const [selectedPrimaryOwner, setSelectedPrimaryOwner] = useState(
    qmsTeamOptions && modalState.data.primaryOwnerId
      ? qmsTeamOptions.find((qto) => qto.value === modalState.data.primaryOwnerId)
      : null
  );

  const handleClick_submit = async (e) => {
    e.preventDefault();

    dispatch({
      type: QMS.ISSUE.UPDATE_CLIENT,
      issueId: modalState.data.issueId,
      fieldsToUpdate: { primaryOwnerId: selectedPrimaryOwner?.value || null },
    });
    await dispatch(cmtIssueActions.update(modalState.data.issueId));
    dispatch(cmtIssueActions.getAll(modalState.data.divisionId));

    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={toggleModal}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={modalState.showModal} toggle={toggleModal} fade={false} size={"md"}>
      <ModalHeader toggle={toggleModal} className="bg-info text-white" close={closeBtn}>
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Edit Primary Owner
      </ModalHeader>
      <ModalBody>
        <div className="form-row mb-2">
          <div className="form-group col-12 mb-0 pr-1">
            <label htmlFor="primaryOwner" className="mb-0">
              <b>Primary Owner:</b>*
            </label>
            <Select
              id="primaryOwner"
              name="primaryOwner"
              value={selectedPrimaryOwner}
              options={qmsTeamOptions}
              onChange={(selected) => setSelectedPrimaryOwner(selected)}
              isClearable
              styles={{
                // Fixes the overlapping problem of the component
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-row form-group mb-0">
          <button className="btn btn-primary" name="save" onClick={handleClick_submit}>
            Save
          </button>
          <button
            className="btn btn-secondary ml-2"
            color="secondary"
            onClick={toggleModal}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
